<template>
    <ResizableLayout
      left_content_class='messages-list'
      :right_content_class="messages_selection.count > 0 || route.name === 'messages-list' ? 'list-dashboard' : null"
    >
        <template #left-content>
            <MessagesListSection
              :folder_id="folder_id"
              :messages_selection="messages_selection"
              :messages_view="messages_view"
              :webmail_view="webmail_view"
              :viewport_controller="viewport_controller"
              :dragdrop_controller="dragdrop_controller"
              @errorRetry="onMessagesErrorRetry"
            />
            <!-- <div class="notifications">
                <i class="fas fa-bell"></i>
                <p>
                    <strong>Receba notificações de novas mensagens</strong>
                    <span>
                        <small>Sim</small>
                        <small>Não</small>
                        <small>Perguntar mais tarde</small>
                    </span>
                </p>
            </div> -->
        </template>

        <template #right-content>
            <MessagesDashboardSection v-if="messages_selection.count > 0"
              :folder_id="folder_id"
              :messages_selection="messages_selection"
              :messages_view="messages_view"
              :webmail_view="webmail_view"
              :viewport_controller="viewport_controller"
            />

            <router-view v-if="route.name !== 'messages-list'"
              :key="route.params.message_id"
              :folder_id="folder_id"
              :viewport_controller="viewport_controller"
              :messages_view="messages_view"
              :webmail_view="webmail_view"
              :messages_selection="messages_selection"
            />

            <UserDashboard v-else-if="messages_selection.count === 0" />
        </template>
    </ResizableLayout>

    <FoldersSelectModal v-if="folders_move_visible === true"
      @folderSubmit="onMessagesMoveSubmit"
      @folderSubmitCancel="onMessagesMoveCancel"
      button_submit_text="messages.actions.move_message"
      title_text="folders.select_folder"
    />

    <AntiSpamModal v-if="antispam_visible === true"
        @actionClose="onAntispamCancel"
        @actionConfirm="onAntispamConfirm"
        :list_type="antispam_list_type"
        :messages_selection="selection_context"
    />


    <ConfirmModal v-if="delete_warning_visible === true"
      text_cancel="global.actions.back"
      confirm_class="danger"
      :title="Language.pluralize('messages.delete.warning_title', selection_context.count)"
      @actionConfirm="onActionDeleteConfirm(selection_context)"
      @actionCancel="onActionDeleteCancel"
    >
      <template #modal_body>
        <p> {{Language.say('messages.delete.warning_text_2')}}  </p>
        <p> {{Language.say('messages.delete.warning_text_3')}}  </p>
      </template>
    </ConfirmModal>

    <ConfirmModal v-if="move_warning_visible === true"
      text_cancel="global.actions.back"
      confirm_class="danger"
      :title="Language.pluralize('messages.move.warning_title', selection_context.count)"
      @actionConfirm="onActionDeleteConfirm(selection_context)"
      @actionCancel="onActionDeleteCancel"
    >
      <template #modal_body>
        <h3> {{Language.say('messages.move.warning_text_1', [selection_context.count])}} </h3>
      </template>
    </ConfirmModal>
</template>

<script setup>
  import {ref, reactive, watch}         from 'vue';
  import {onBeforeMount, onUnmounted}   from 'vue';
  import {defineProps}                  from 'vue';
  import {useRoute, useRouter}          from 'vue-router';
  import MessagesListSection            from './Sections/MessagesListSection.vue';
  import MessagesDashboardSection       from './Sections/MessagesDashboardSection.vue';
  import ResizableLayout                from '@/vue/Layouts/ResizableLayout.vue';
  import UserDashboard                  from '@/vue/Views/Webmail/Sections/UserDashboard.vue';
  import FoldersSelectModal             from '@/vue/Views/Folders/Modals/FoldersSelectModal.vue';
  import ConfirmModal                   from '@/vue/Views/Webmail/Modals/ConfirmModal.vue';
  import AntiSpamModal                  from '@/vue/Views/Settings/AntiSpam/Modals/AntiSpamModal.vue';
  import MessagesSelectionCollection    from '@/js/Mailboxes/Collections/MessagesSelectionCollection';
  import ViewportController             from '@/js/Mailboxes/ViewportController';
  import BrowserNotificationsController from '@/js/Webmail/Notifications/BrowserNotificationsController';
  import MetadataController             from '@/js/Webmail/MetadataController';
  import DragDropController             from '@/js/Webmail/DragDrop/DragDropController';
  import StateConsumer                  from '@/js/Shared/State/StateConsumer';
  import FoldersController              from '@/js/Mailboxes/FoldersController';
  import Language                       from '@/js/Shared/Language/Language';
  import SAPOMailConfig                 from '@/SAPOMailConfig';

  const props = defineProps({
    webmail_view: {}
  })

  const route                  = useRoute();
  const router                 = useRouter();
  const dragdrop_controller    = DragDropController;
  const viewport_controller    = ViewportController;
  const messages_selection     = reactive(new MessagesSelectionCollection());
  const folder_id              = route.params.folder_id;
  const folders_move_visible   = ref(false);
  const antispam_visible       = ref(false);
  const delete_warning_visible = ref(false);
  const move_warning_visible   = ref(false);
  const antispam_list_type     = ref(null);
  const selection_context      = ref();
  const folder                 = ref({});
  const title                  = {
    folder_unread  : null,
    folder_name    : null,
    message_subject: null,
  }

  onBeforeMount(async () => {
    FoldersController.broadcaster.on('folders-deleted', onFoldersDelete);

    await fetchMessages();
    setFolder();
    setFolderTitle();
  })

  onUnmounted(() => {
    FoldersController.broadcaster.destroy('folders-deleted', onFoldersDelete);
  })

  watch(FoldersController.collection_state.last_updated, async (folder) => {
    onFoldersSwitch(folder);
  });


  const onFoldersDelete = (folder) => {
    closeFolderOnDelete(folder);
  }

  const onFoldersSwitch = (folder) => {
    switchFolder(folder);
  }

  const onMessagesErrorRetry = async () => {
    await fetchMessages();
    setFolder();
    setFolderTitle();
  }

  const onMessagesMoveSubmit = async (folder) => {
    setFoldersMoveVisibility(false);

    if (await viewport_controller.moveMessages(folder_id, folder, selection_context.value.getIndexKeys()) === false) {
      return;
    }

    closeMessageOnAction(selection_context.value);
    messages_selection.reset();
  }

  const onMessagesMoveCancel = () => {
    setFoldersMoveVisibility(false);
  }

  const onActionSelectAll = (messages) => {
    messages_selection.addItems(messages);
  }

  const onActionSelectReset = () => {
    messages_selection.reset();
  }

  const onActionDelete = async (selection) => {
    setSelectionContext(selection);
    let config = SAPOMailConfig.client.folders;

    if (selection.count >= config.delete_warning.count) {
      setMoveWarningVisibility(true);
      return;
    }

    if (config.delete_warning.enabled[folder_id] || selection.count >= config.delete_warning.count) {
      setDeleteWarningVisibility(true);
      return;
    }

    await onActionDeleteConfirm(selection);
  }

  const onActionDeleteCancel = () => {
    setDeleteWarningVisibility(false);
    setMoveWarningVisibility(false);
  }

  const onActionDeleteConfirm = async (selection) => {
    setDeleteWarningVisibility(false);
    setMoveWarningVisibility(false);

    await viewport_controller.trashMessages(
      folder_id,
      selection.getIndexKeys()
    );

    closeMessageOnAction(selection);
    selection.reset();
  }

  const onActionMove = (selection) => {
    setSelectionContext(selection);
    setFoldersMoveVisibility(true);
  }

  const onActionRead = async (selection) => {
    await viewport_controller.flagRead(folder_id, selection.getIndexKeys());
    messages_selection.reload();
    setFolderTitle();
  }

  const onActionUnread = async (selection) => {
    await viewport_controller.flagUnread(folder_id, selection.getIndexKeys());
    messages_selection.reload();
    setFolderTitle();
  }

  const onActionFlag = async (selection) => {
    await viewport_controller.flagFlagged(folder_id, selection.getIndexKeys());
    messages_selection.reload();
  }

  const onActionUnflag = async (selection) => {
    await viewport_controller.flagUnflagged(folder_id, selection.getIndexKeys());
    messages_selection.reload();
  }

  const onActionSpam = async (selection) => {
    await viewport_controller.markSpam(folder_id, selection.getIndexKeys());
    closeMessageOnAction(selection);
    messages_selection.reset();
  }

  const onActionNotSpam = async (selection) => {
    await viewport_controller.markNotSpam(folder_id, selection.getIndexKeys());
    closeMessageOnAction(selection);
    messages_selection.reset();
  }

  const onActionBlacklist = (selection) => {
    setSelectionContext(selection);
    setAntispamVisibility(true);
    setAntispamListType('blacklist');
  }

  const onActionWhitelist = (selection) => {
    setSelectionContext(selection);
    setAntispamVisibility(true);
    setAntispamListType('whitelist');
  }

  const onAntispamCancel = () => {
    setAntispamVisibility(false);
  }

  const onAntispamConfirm = () => {
    setAntispamVisibility(false);
  }

  const onActionAddFilter = (selection) => {
    StateConsumer.set('filters_conditions_recipients', selection.getRecipientEmails());
    router.push('/settings/filters/add');
  }

  const onActionForward = (selection) => {
    props.webmail_view.routeTo('/compose', {
      action : 'forward',
      mbox   : folder_id,
      uid    : selection.getIndexKeys().join(','),
    })
  }

  const setFolderTitle = () => {
    title.folder_name   = folder.value.name   || null;
    title.folder_unread = folder.value.unread || 0;

    if (route.query.qs) {
      title.folder_name = 'messages.list.search.results.title';
    }

    setPageTitle();
  }

  const setMessageTitle = (subject) => {
    title.message_subject = subject;
    setPageTitle();
  }

  const setPageTitle = () => {
    let page_title = '';

    if (title.folder_unread) {
      page_title += `(${title.folder_unread}) `;
    }

    if (title.folder_name) {
      page_title += title.folder_name;
    }

    if (title.message_subject) {
      page_title += ` - ${title.message_subject}`;
    }

    MetadataController.setPageTitle(page_title);
  }

  const setFolder = () => {
    folder.value = viewport_controller.mailboxes.folders.all.get(folder_id);
  }

  const setSelectionContext = (selection) => {
    selection_context.value = selection;
  }

  const sendBrowserNotification = () => {
    let message = viewport_controller.mailboxes.viewport.get(folder_id).getLastAdded();

    if (!message) {
      return;
    }

    BrowserNotificationsController.notify(
      message.subject,
      message.sender.name || message.sender.email,
      {folder_id: folder_id, message_id: message.id},
    )
  }

  const fetchMessages = async() => {
    if (route.query.qs && route.query.qs === 'quicksearch' || route.query.qs === 'filter' ) {
      await viewport_controller.fetchMessagesQuickSearch(route.query);
      return;
    }

    let zone = route.query.qs && route.query.qs === 'fullsearch' ? 'fullsearch_list' : 'messages_list';

    await viewport_controller.fetchMessages(folder_id, null, zone);
  }

  const closeFolderOnDelete = (folder) => {
    if (route.params.folder_id !== folder.id) {
      return;
    }

    props.webmail_view.routeTo('/');
  }

  const switchFolder = (state) => {
    if (route.params.folder_id !== state.previous.id) {
      return;
    }

    props.webmail_view.routeTo('/messages/' + state.current.id);
  }

  const closeMessageOnAction = (selection) => {
    if (!selection.index[route.params.message_id]) {
      return;
    }

    props.webmail_view.routeTo('/messages/' + folder_id);
  }

  const setFoldersMoveVisibility = (value) => {
    folders_move_visible.value = value;
  }

  const setDeleteWarningVisibility = (value) => {
    delete_warning_visible.value = value;
  }

  const setMoveWarningVisibility = (value) => {
    move_warning_visible.value = value;
  }

  const setAntispamVisibility = (value) => {
    antispam_visible.value = value;
  }

  const setAntispamListType = (type) => {
    antispam_list_type.value = type;
  }

  const messages_view = {
    onActionSpam       : onActionSpam,
    onActionNotSpam    : onActionNotSpam,
    onActionRead       : onActionRead,
    onActionUnread     : onActionUnread,
    onActionMove       : onActionMove,
    onActionDelete     : onActionDelete,
    onActionBlacklist  : onActionBlacklist,
    onActionWhitelist  : onActionWhitelist,
    onActionFlag       : onActionFlag,
    onActionUnflag     : onActionUnflag,
    onActionForward    : onActionForward,
    onActionAddFilter  : onActionAddFilter,
    onActionSelectAll  : onActionSelectAll,
    onActionSelectReset: onActionSelectReset,
    setMessageTitle    : setMessageTitle,
    setFolderTitle     : setFolderTitle,
  };

</script>
